<template>
	<div>
		<strong>Please use the TBS Grading Guidelines as a reference to create and maintain your own grading system.</strong>
    <br /><br />
    We strongly recommend publishing your grading system on your website and including it with every invoice when selling used equipment. Clear and consistent grading standards help avoid misunderstandings and disputes between buyers and sellers.
    <br />
    TBS advises to only buy or sell used equipment with an item by item description.
    <br /><br />
	To file a complaint against another member, please visit the company’s profile page on TBS and click the “File Complaint” button. Be sure to include a short but clear description of the issue and upload both the Purchase Order (PO) and Invoice.
	<br><br>
	Please note that the quality/grade of the goods must be clearly stated on both the PO and Invoice. Complaints submitted without this information cannot be processed.
	<br><br>
	<strong>Important Notes:</strong>
	<ul class="list-disc list-inside">
		<li>TBS does not mediate disputes involving <strong>C-grade or D-grade hardware.</strong></li>
		<li>TBS does not mediate transactions with a value below <strong>€2,000.</strong></li>
		<li>TBS does not mediate disputes involving goods sold <strong>“As Is.”</strong></li>
		<li>We strongly recommend purchasing “As Is” goods only from companies with whom you have an established long-term relationship.</li>
		<li>TBS does not mediate disputes related to software transactions.</li>
	</ul>
	<br /><br />

    <table class="bg-white">
    	<thead>
		    <tr class='bg-gray-100'>
		      <th width=50><strong>Grade</strong></th>
		      <th width=145>Desktop</th>
		      <th width=145>Laptop</th>
		      <th width=145>Monitor</th>
		      <th width=145>Server</th>
		      <th width=145>Mobile Phone/Tablet</th>
		      <th width=145>Printers</th>
		    </tr>
	  	</thead>
	    <tbody>
		    <tr>
		      <td class="text-center"><strong>A</strong></td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Good cosmetic condition with minimal signs of use.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Good cosmetic condition with minimal signs of use.</li>
		      		<li>Maximum 5 pixel defects.</li>
		      		<li>Includes adaptor.</li>
		      		<li>Battery health minimum 80%</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Good cosmetic condition with minimal signs of use.</li>
		      		<li>Maximum 5 pixel defects.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Good cosmetic condition with minimal signs of use.</li>
		      		<li>Includes rails.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Good cosmetic condition with minimal signs of use.</li>
		      		<li>Maximum 5 pixel defects.</li>
		      		<li>Includes adaptor.</li>
		      		<li>Battery health minimum 80%</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Complete, cleaned, tested and functional.</li>
		      		<li>Good cosmetic condition with minimal signs of use.</li>
		      		<li>Minor discoloration acceptable on older units.</li>
		      		<li>Not classified as refurbished or mint condition.</li>
		      	</ul>
		      </td>
		    </tr>
		    <tr>
		      <td class="text-center"><strong>B</strong></td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Cosmetic wear such as scratches, small cracks or removed labels.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Cosmetic wear acceptable.</li>
		      		<li>Adaptor may be missing.</li>
		      		<li>Device should power on using battery.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Cosmetic wear acceptable.</li>
		      		<li>Minor LCD marks acceptable.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Cosmetic wear acceptable.</li>
		      		<li>Rails may be missing.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Fully functional and tested.</li>
		      		<li>Cosmetic wear acceptable.</li>
		      		<li>Adaptor may be missing.</li>
		      		<li>Device should power on using battery.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Cleaned, tested and functional.</li>
		      		<li>Cosmetic flaws or missing covers possible.</li>
		      		<li>Minor defects must be disclosed with sale.</li>
		      	</ul>
		      </td>
		    </tr>
		    <tr>
		      <td class="text-center"><strong>C</strong></td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Repairable but not fully functional.</li>
		      		<li>Missing parts possible.</li>
		      		<li>BIOS/password locked possible.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Repairable but not fully functional.</li>
		      		<li>Missing parts, keys, battery or LCD defects possible.</li>
		      		<li>BIOS/password locked possible.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Defective or for parts only.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Repairable but not fully functional.</li>
		      		<li>Missing parts or rails possible.</li>
		      		<li>Password locked possible.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Repairable but not fully functional.</li>
		      		<li>Missing parts or screen defects possible.</li>
		      	</ul>
		      </td>
		      <td>
		      	<ul class="list-disc pl-4">
		      		<li>Sold as-is.</li>
		      		<li>May be working or non-working.</li>
		      		<li>Usually DOA warranty only or no warranty.</li>
		      	</ul>
		      </td>
		    </tr>
		    <tr>
		      <td class="text-center"><strong>D</strong></td>
		      <td>BER / Scrap / Parts only.</td>
		      <td>BER / Scrap / Parts only.</td>
		      <td>BER / Scrap / Parts only.</td>
		      <td>BER / Scrap / Parts only.</td>
		      <td>BER / Scrap / Parts only.</td>
		      <td>BER / Scrap / Parts only.</td>
		    </tr>
	  	</tbody>
    </table>
	</div>
</template>

<script>

export default {
  name: 'GradingGuidelinesBody',
}
</script>
<style scoped>
	table {
		border-collapse: collapse;
		table-layout: fixed;
		width: 100%;
	}

	td, th{
		vertical-align: top;
		padding: 8px;
		border: 1px solid #555;
	}

	ul {
		margin: 0;
	}

	td:first-child,
	th:first-child {
		width: 50px;
	}
</style>